import { InjectionToken } from '@angular/core';

export interface AuthRoutes {
  /** Where to send unauthenticated users. */
  loginUrl: string;
  /** Where to send already-authenticated users who hit a guest-only page. */
  homeUrl: string;
  /** Where to send users mid-TFA. Optional — apps without TFA omit it. */
  tfaUrl?: string;
  /** Where to send users who haven't completed the questionnaire. Optional. */
  questionnaireUrl?: string;
  /** Where to send users who haven't completed KYC verification. Optional. */
  kycUrl?: string;
  /** Where to send first-login users to set up 2FA. Optional. */
  tfaSetupUrl?: string;
  /** Where to send users when a network error (offline) is detected. Optional. */
  networkErrorUrl?: string;
  /** Where to send users when the service is unavailable (503). Optional. */
  serviceUnavailableUrl?: string;
}

export const AUTH_ROUTES = new InjectionToken<AuthRoutes>('auth.routes');
